import { EventEmitter } from "events";

export const currencyFormatter = (currency: any) => {
    currency.iso_link = currency.iso + (currency.network ? '_' + currency.network: '');
}

export const eventEmitter = new EventEmitter();